export default __webpack_public_path__ + "static/media/location.01b28c1a.png";